import React from "react";
import ProfileListingPageLayout from "../components/ProfileListingPageLayout";
import Carousel from "../components/Carousel";
import carouselImages from "../data/carouselImages";

const Kemper: React.FC = () => {
  const description = (
    <p className="opacity-70 mt-4 text-xl lg:text-xl">
      Legendary Mesa & Diezel Kemper Profiles. Explore our premium Kemper
      Profiles, capturing the iconic tones of Mesa Boogie and Diezel amps.
      Recreate sounds from Dream Theater albums, SRV's 'Texas Flood,' and more.
      Discover vintage Mark IIA, modern Mark V 35, and powerful Einstein tones.
      Free profile included. Elevate your Kemper experience today.
    </p>
  );

  return (
    <div className="bg-emerald-900">
      <Carousel images={carouselImages} className=" max-h-1/6" />{" "}
      {/* This div now provides the background */}
      <ProfileListingPageLayout
        pageTitle="Kemper Profiles"
        pageDescription={description}
        profileTypeFilter="kemper"
        // titleGradientClass can be added if Kemper page has a specific one
      />
    </div>
  );
};
export default Kemper;
